module.exports = __webpack_public_path__ + "static/landing-789e615fe878ebbc39fb5d77a046e653.svg";